import { logUnusedKeys } from '@/model/Utils'

export default function (other) {
  other = other || {}
  let result = {
    id: other.id || null,
    userId: other.userId || null,
    creationTime: other.creationTime || null,
    status: other.status || null,
    duration: other.duration || null,
    start: other.start || null,
    end: other.end || null,
    lastStart: other.lastStart || null,
    lastEnd: other.lastEnd || null,
    type: other.type || null,
    title: other.title || null,
    body: other.body || null,
    location: other.location || null,
    url: other.url || null,
    color: other.color || null,
    // Always an ARRAY — a single-select picker can hand over one bare id
    // string, and the backend needs a Set (["id"], never "id").
    clientsIds: Array.isArray(other.clientsIds) ? other.clientsIds : (other.clientsIds ? [other.clientsIds] : []),
    users: other.users || [],
    orgId: other.orgId || null,
  }
  logUnusedKeys('CalendarRequest', result, other)
  return result
}
